export const engTexts = {
	knowMore: 'Know more',
	ngoPurpose:
		"To raise funds for the NGO's projects, keep you up	to date on the NGO and the progress of the project you donated to and issue tax	deduction certificates.",
	termsRights:
		'You have	the right to access, correct and delete your data, as well as other rights, as explained	in the additional information.',
	termsAdditionalInfo:
		'You can consult additional and detailed Data Protection information on our <a href="https://www.worldcoo.com/gdpr">website</a> or by <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>',
	termsRecipients:
		'No data will be transferred to third parties, except those responsible for treatment outside the EU, hosted by Privacy Shield.',
	unexpectedError: 'There was an unexpected error',
	authError: 'There was an error authorising the payment',
	amountError: 'The amount was not valid',
	referralError: 'There was a referral error',
	cardError: 'There was an error with your card',
	transactionError: 'There was an error with the transaction',
	FundedByEmployees: `Funded by employees`,
	resetFilters: 'Delete filters',
	category: 'Cause',
	basicNeeds: 'Basic needs',
	humanRights: 'Human rights',
	education: 'Education',
	emergency: 'Emergency',
	feeding: 'Feeding',
	environment: 'Environment',
	habitat: 'Habitat',
	health: 'Health',
	clear: 'Clear',
	active: 'Active',
	finished: 'Finished',
	status: 'Status',
	filters: 'Filters',
	year: 'Year',
	treesFAQ1: 'Please can you provide more information on Conservation International (“CI”) and their purpose.?',
	treesFAQ2: 'What is the Dedicate a Tree option?',
	treesFAQ3: 'Will any fees be taken out of my donation? Will the Conservation International receive my full donation?',
	treesFAQ4:
		'What is Worldcoo? Why will my donation be directed there and not directly to Conservation International? \n',
	treesFAQ5: 'How will this donation appear on my bank statement? ',
	treesFAQ6: 'How the donation matching works?',
	treesFAQResponse1:
		'CI is a non-profit environmental organization, which has been recognised as a 501(c)(3) charitable organization in the United States. Note that CI is not a registered charity in the England and Wales or any other part of the United Kingdom. CI’s main priorities are: (i) protecting nature to halt climate catastrophe; (ii) protecting the ocean to protect humanity; and (iii) piloting sustainable lands and waters. Since their inception, they’ve helped to protect more than 6 million square kilometers (2.3 million square miles) of land and sea across more than 70 countries. Currently with offices in 29 countries and 2,000 partners worldwide, their reach is truly global. Please see their website for more details: https://www.conservation.org/about',
	treesFAQResponse2:
		'You can dedicate your donation to a friend or family member (“Recipient”). If you choose this option, Mastercard Donate will send an email to the Recipient on your behalf at the email address you provide for the Recipient.  If you do not wish to use the Dedication option, you can simply skip that step and proceed with your donation. ',
	treesFAQResponse3:
		'You will not be charged additional fees, however, from your donation amount deductions will be made for standard card processing fees and Worldcoo S.L. (“Worldcoo”), a fundraising intermediary, will charge Conservation International a 6% administrative fee on your donation and will recover any applicable standard transaction processing fees incurred by them. When affecting payment of your donation  to Conservation International, Worldcoo will convert this from EUR into USD using the prevailing exchange rate.',
	treesFAQResponse4:
		'Worldcoo is a Spanish corporation, which specializes in allowing e-commerce sites to fund social and cooperation projects. Mastercard works with Worldcoo to facilitate donations to  Conservation International. Worldcoo will make a corresponding payment in the amount you donated to Conservation International in US dollars. Donations are non-refundable. Worldcoo will appear as the merchant of record for your card charged in the amount of your donation. Conservation International will receive the funds within three months of your original donation. In the unlikely and unfortunate event that one of the Charities is not able to accept funds collected via the Site (for example, because they cease to exist or they lose their charitable status etc.), your donation will be refunded to you by Worldcoo without undue delay via the same payment method as the donation has been made.',
	treesFAQResponse5:
		'Worldcoo will appear as the merchant of record in the amount of your donation on the card charged for Conservation International. ',
	treesFAQResponse6:
		'Don’t forget, donations made using your Mastercard, can have an even bigger impact. Mastercard is matching donations made in France to Conservation International using a Mastercard at the donate page linked above, until May 15th 2021, tree for tree, pound for pound, up to an aggregate total of Euro 20,000 . See the donate page for additional terms and conditions . Thank you for helping us Start Something Priceless. ',

	costPerTreeAproximate: 'Cost per tree is approximate.',
	treesDonateInputMessage: 'Use your Mastercard to donate and we’ll match you tree for tree-euro for euro.**',
	aboutConservationInternational: 'About Conservation International',
	dedicateToTemplate:
		'Hello! You receive this email because {{donorName}} has given you a donation of {{amount}} {{currency}} for the NGO {{ngoName}} in the campaign {{campaignName}}. This donation has been dedicated to you with the intention of making the world a little better place',

	dedicateToTemplateTitle: 'Send them a note and let them know you care.',
	dedicateToWarning:
		'This message will be sent to the Recipient at the email address provided above. I confirm that I have sought permission from the recipient to send this message',
	dedicateToRecipientEmail: 'Recipient email',
	dedicateToRecipientName: 'Recipient name',
	dedicateDonationTitle: 'I would like to dedicate this donation to someone.',
	dedicateDonationMessage: 'I would like to dedicate my donation to someone',
	responsable: 'Controller',
	purpose: 'Purpose',
	legitimation: 'Lawfullness',
	recipients: 'Recipients',
	rights: 'Rights',
	telefonicaTermsAndConditionsLink: 'to the terms of the Legal Notice of Fundación Telefónica',
	ngoAdditionalInfoTitle: 'Location and additional information',
	termsButton: 'I have read, and agree',
	id: 'ID Number',
	taxId: 'Tax ID Number',
	passport: 'Passport',
	others: 'Others',
	campaignAudited: 'Campaign audited by',
	termsAndCons: 'terms of Worldcoo Data Protection',
	ngoTerms: 'Data Protecion terms of',
	haveReadAndAccept: 'I have read, understand and accep the',
	aCampaignBy: 'A campaign by',
	acceptNgoTermsLink: '{{ngo}} Data Privacy Notice',
	acceptRecurrentTermsLink:
		'I have read, understand and accept the <a class="terms_button" data-open-modal="recurrentTerms" data-modal-classes="terms-modal full-scroll" href="#">NGOs Data Protection terms</a>',
	activities: 'Activities',
	additionalInfo: 'Additional information',
	anyComments: 'Do you have any comments?',
	businessName: 'Company name',
	campaignObjectives: 'Campaign objectives',
	campaignFunded: 'Campaign funded!',
	campaigns: 'Campaigns',
	cancel: 'Cancel',
	cardBrandNotAccepted: 'This card brand is not accepted.',
	cardRegisteredSuccessfully: 'The card has been successfully registered',
	cardsSupported: 'Cards supported:',
	certificateOnlyValidInExpeditionCountry:
		'The donation certificate will only be valid in the country of origin where the beneficiary entity is registered.',
	certificateNeededData: 'Data necessary to obtain the donation certificate:',
	change: 'Change',
	checkoutSuccess: 'Your donation has been made correctly, thank you for participating.',
	city: 'City',
	collectedFundsDistribution: 'The funds raised will be distributed equally among the following projects:',
	comments: 'Comments',
	company: 'Company',
	confirm: 'Confirm',
	contactData: 'Enter your details',
	cookiesMessage: 'This website uses cookies. If you continue browsing we will consider you have accepted their use.',
	country: 'Country',
	creditCard: 'Credit card',
	dataReceivedSuccessfully: 'We have correctly received your data.',
	description: 'Description',
	directBeneficiaries: 'Direct beneficiaries',
	directBeneficiariesDescription: "Those people who have naturally benefited from the campaign's interventions",
	documentNumber: 'Document number',
	documentType: 'Type of document',
	donationAmount: 'Donation amount',
	donationAmountError: 'Donation amount is not valid',
	donationAmountMinimumIs: 'The minimum amount is {{amount}}',
	donationCertificate: 'Donation certificate',
	donations: 'Donations',
	donors: 'Donors',
	donated: 'Donated',
	donatedOf: 'Donated of',
	donateMonthly: 'Donate monthly',
	donationOnBehalf: 'Make a donation on behalf of',
	door: 'Door',
	email: 'Email',
	fillFollowingFields: 'Fill in the following fields',
	finish: 'Finish',
	floor: 'Floor',
	funded: 'Funded',
	genericCardError: 'An error has occurred with your card.',
	goBack: 'Back',
	identityDocument: 'Identity document',
	indicateDataToIdentify: 'Fill in this information so we can identify your donation.',
	indirectBeneficiaries: 'Indirect beneficiaries',
	indirectBeneficiariesDescription:
		"Those identifiable people who will potentially receive an effect from the campaign's activities",
	inDoubtContactHere: 'Any questions you have you can contact us here:',
	informYouViaMail: 'We will inform you in detail by email.',
	makeDonation: 'Donate',
	makeOneTimeDonation: 'Donate',
	makeYourDonation: 'Make your donation',
	manageMyDonations: 'Manage my donations',
	manyThanks: 'Thank you!',
	manyThanksExtra: 'Your contribution will be doubled!',
	modifyAmount: 'Modify the donation amount',
	modifyRecurrentDonationSuccess:
		'<p class="margin-top-40">We have received your request correctly.</p><p>In a few days we will send you an email confirming that we have made the changes you have requested.</p><p>If you have any questions, you can contact us here:</p><p class="margin-top-20"><strong><a href="mailto:contact@worldcoo.com">contact@worldcoo.com</a></strong></p>',
	modifyRecurrentDonationTitle: 'Here you can modify or cancel your donation:',
	moreInfo: 'Further information',
	name: 'Name',
	next: 'Next',
	otherAmount: 'Other amount',
	overlayError:
		'<p>An error has occurred</p><p>Please try again later or contact us here:</p><p><strong>contact@worldcoo.com</strong></p>',
	particular: 'Individual',
	paymentData: 'Payment data',
	paymentType: 'Form of payment',
	personalData: 'Personal data',
	pleaseFillFields: 'Please fill in the following information:',
	postalCode: 'Postal code',
	province: 'Province',
	raised: 'Raised',
	raisedTillNow: 'Raised until now:',
	recurrentFormError: 'Some error has occurred processing your request. Please try again later or contact us here:',
	region: 'Region',
	repeatEmail: 'Rewrite email',
	repsolEmployeesPortal: 'Employees Giving Platform',
	seeCampaigns: 'See campaigns',
	send: 'Send',
	share: 'Share',
	sorry: 'We are sorry!',
	stairNumber: 'Stairs',
	step1: 'Step 1',
	step2: 'Step 2',
	step3: 'Step 3',
	step4: 'Step 4',
	stopMakingDonation: 'Stop donating monthly',
	streetName: 'Street name',
	streetNumber: 'Number',
	streetType: 'Street type',
	summary: 'Summary',
	surname: 'Surname',
	telefonicaUseCorporateMail: '* If you are an active Telefonica employee please use your corporate email.',
	thanks: 'Thank you!',
	typeTheAmount: 'Type the amount',
	unavailableLanguageMessage:
		'We do not have the content of this campaign in english. We are constantly working to provide more content in your language. Thank you for your patience.',
	updatesAndLinks: 'Updates and links',
	validationEqualFields: '{{label}} and {{fieldName}} are not equal',
	validationIsRequired: '{{label}} field is required',
	validationValidEmail: '{{label}} field is not a valid email',
	viewCampaignInfo: 'View campaign information',
	viewInfo: 'View info',
	wantCertificate: 'I would like to receive a donation certificate',
	wantWorldcooNewsletter: 'I want to receive information about Worldcoo',
	whatIsNewAmount: 'Tell us what is the new amount you want to donate (in {{currency}}):',
	whatYouWantToDo: 'What do you want to do?',
	whoWillBenefit: 'Who will benefit?',
	youCanAlsoDonateOneTime:
		'If you prefer to make a one-time donation to any of them, please start by clicking one of the following links.',
	yourDonationWillBeCharged: 'Your donation will be charged on the 15th of each month.',
	yourRequestIsProcessing: 'Your request is being processed. Wait a few seconds, please.',
	youSureCancelRecurrentDonation: 'Are you sure you want to stop making a monthly donation?',
	ngoTermsTitle: 'Basic information about Data Protection',
	termsPurpose:
		'Manage the business relationship in all its areas, as well as your donation and certificate request, and the sending of commercial communications electronically.',
	ngoLegitimation: 'The legal basis for handling your data is your consent.',
	ngoRecipients: 'No data shall be transferred to third parties.',
	ngoRights:
		'It has the right to access, correct and delete data, as well as other rights, as explained in the additional information.',
	ngoAdditionalInfoEmail:
		'You can consult the additional and detailed information on Data Protection on the website of each NGO.',
	amountMustBeGreaterThanZero: 'The amount must be greater than 0',
	amountMustBeLowerThan3000: 'The amount must be less than 3000',
	inSupportOf: 'In support of',
	metafieldsNoTicket: 'Row 0. Donation without entry',
	metafieldsTickets:
		'How many invitations do you need for the concert? Please note that for every €10 donated you get one invitation.',
};
